/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import styles from "../Invoice.module.scss";
import {
  GetInvoiceList,
  putInvoiceStatusUpdate,
} from "../../../../apiServices";
import {
  calculatePendingDays,
  capitalizeWords,
  dateFormateDD,
  formatAmount,
  MyModal,
  textTruncate,
} from "../../../../utility";
import { useDispatch, useSelector } from "react-redux";
import {
  commonPopupActions,
  InvoiceDataFilterAction,
} from "../../../../redux-store/store";
import {
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styled from "styled-components";
import { BsDot, BsThreeDotsVertical } from "react-icons/bs";
import InvoiceTableFilter from "./InvoiceTableFilter";
import ModalContainer from "../../../../components/modal_popup";
import SuccessTick from "../../../../components/success_tick";
import { AiOutlineClose } from "react-icons/ai";
import { BiRefresh } from "react-icons/bi";
import _ from "lodash";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#d2d2d2",
    color: "#545454f0",
    padding: "8px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "9px",
  },
}));
const InvoiceTableView = () => {
  const InvoiceData = useSelector(
    (state) => state.InvoiceDataDetails.InvoiceDataFilter
  );
  const InvoiceDataPage = useSelector(
    (state) => state.InvoiceDataDetails.InvoiceDataFilter.page
  );
  const [loading, setLoading] = useState(false);
  const debounceFetchRef = useRef();
  const [invoiceId, setInvioceId] = useState();
  const [openInvoiceStatus, setOpenInvoiceStatus] = useState(false);
  const [successTick, setsuccessTick] = useState(false);
  const [isRotating, setIsRotating] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);
  const [errors, setErrors] = useState({});
  const [modalContent, setModalContent] = useState({
    action: "",
    placeholder: "",
    showInput: false,
  });
  const [formdata, setFormdata] = useState({
    amount_received: "",
    reason_for_cancel: "",
    amount_received_date: "",
    amount_adjustment_details: "Full amount received",
    notes: "",
  });

  const [enableSubmit, setEnableSubmit] = useState(false);

  const dispatch = useDispatch();
  const [invoiceData, setInvoiceData] = useState([]);
  const [dataCount, setDataCount] = useState({
    totalCount: "",
    currentpage: "",
    totalPage: 1,
  });
  useEffect(() => {
    // console.log(InvoiceData);
  }, [InvoiceData, InvoiceDataPage]);
  useEffect(() => {
    // Define the debounced function
    debounceFetchRef.current = _.debounce(async () => {
      setLoading(true);
      try {
        const data = await GetInvoiceList(InvoiceData);
        setInvoiceData(data.data);
        setDataCount({
          totalCount: data.pagination.totalPages,
          totalPage: data.pagination.totalCount,
        });
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      } finally {
        setLoading(false);
      }
    }, 300); // 300ms debounce delay

    // Call the debounced function
    debounceFetchRef.current();

    // Cleanup function to cancel the debounced function if the component unmounts
    return () => {
      debounceFetchRef.current.cancel();
    };
  }, [InvoiceData]);
  function candidatePagination(event, page) {
    const currentPage = page;
    // console.log(event, "current page");
    dispatch(InvoiceDataFilterAction.setInvoicePage(currentPage));
  }
  const handlePopupDetails = (id, type) => {
    // console.log(id);

    dispatch(
      commonPopupActions.setShowPopup({
        name: type,
        id: id,
      })
    );
    dispatch(InvoiceDataFilterAction.setInvoiceempID(id));
  };

  function handleInvoiceSizeChange(size) {
    dispatch(InvoiceDataFilterAction.setInvoiceSize(size));
  }

  const handleActionClick = (action) => {
    if (action === "pending") {
      setModalContent({
        action: "pending",
        placeholder: "",
        showInput: false,
      });
    } else if (action === "cancelled") {
      setModalContent({
        action: "cancelled",
        placeholder: "Enter Reason for Cancellation",
        showInput: true,
      });
    } else if (action === "received") {
      setModalContent({
        action: "received",
        placeholder: "Enter Amount",
        showInput: true,
      });
    }
    setOpenInvoiceStatus(true);
  };
  const validateInputs = () => {
    const newErrors = {};
    if (
      modalContent.action === "cancelled" &&
      !formdata.reason_for_cancel.trim()
    ) {
      newErrors.reason_for_cancel = "Reason for cancellation is required.";
    }
    if (modalContent.action === "received") {
      if (!formdata.amount_received.trim()) {
        newErrors.amount_received = "Amount is required.";
      }
      if (!formdata.amount_received_date) {
        newErrors.amount_received_date = "Amount received date is required.";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prev) => ({ ...prev, [name]: value }));

    // Clear the specific error for the field being updated
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;
    const payload = {
      invoice_id: invoiceId.invoice_id,
      status: modalContent.action,
      amount_received:
        modalContent.action === "received" ? formdata.amount_received : null,
      amount_received_date:
        modalContent.action === "received"
          ? formdata.amount_received_date
          : null,
      reason_for_cancel:
        modalContent.action === "cancelled" ? formdata.reason_for_cancel : null,
      invoice_no: invoiceId.invoice_no,
      amount_adjustment_details: formdata.amount_adjustment_details,
    };

    setsuccessTick(true);
    try {
      const result = await putInvoiceStatusUpdate(payload);
      // console.log("API Response:", result);
      setOpenInvoiceStatus(false); // Close modal after successful submission
      setTimeout(() => {
        setsuccessTick(false);
        setOpenInvoiceStatus(false);
        setFormdata({
          amount_received: "",
          amount_received_date: "",
          reason_for_cancel: "",
        });
      }, 3000);
      try {
        const data = await GetInvoiceList(InvoiceData);
        // console.log(data.data, "InvoiceData");
        setInvoiceData(data.data);
        setDataCount({
          totalCount: data.pagination.totalPages,
          totalPage: data.pagination.totalCount,
        });
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      }
    } catch (error) {
      console.error("Error updating invoice status:", error);
    }
  };
  const handleRefresh = async () => {
    setIsRotating(true);
    setLoading(true);
    try {
      const data = await GetInvoiceList(InvoiceData);
      // console.log(data.data, "InvoiceData");
      setInvoiceData(data.data);
      setDataCount({
        totalCount: data.pagination.totalPages,
        totalPage: data.pagination.totalCount,
      });
      setTimeout(() => {
        setIsRotating(false);
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    }
  };
  return (
    <>
      <div className={`mt-2 container-fluid ${styles.invoiceContainer}`}>
        <div className="d-flex">
          Show{" "}
          <select
            className="px-1 py-1 mx-2"
            onChange={(event) => handleInvoiceSizeChange(event.target.value)}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
          </select>{" "}
          Entries
        </div>
        <div className="d-flex align-items-center justify-content-center gap-4">
          <div onClick={handleRefresh}>
            <BiRefresh
              className={`fs-4 
                 ${isRotating ? styles.refreshRotate : styles.refreshcolor}
                `}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div>
            Total Count : <b>{dataCount.totalPage}</b>
          </div>
          <div>
            <InvoiceTableFilter />
          </div>
        </div>
      </div>

      <div>
        <div className={`${styles.Container} mt-3`}>
          <div className={`table-responsive-sm ${styles.responsive}`}>
            <TableContainer className={`${styles.TableContainer}`}>
              <Table stickyHeader aria-label="sticky table" className={``}>
                <TableHead className={`${styles.Header}`}>
                  <TableRow>
                    <StyledTableCell>Invoice Number</StyledTableCell>
                    <StyledTableCell>Invoice Category</StyledTableCell>
                    <StyledTableCell>Company Name</StyledTableCell>
                    <StyledTableCell>Invoice Date</StyledTableCell>
                    <StyledTableCell>Actual Amount</StyledTableCell>
                    <StyledTableCell>GST 18%</StyledTableCell>
                    <StyledTableCell>Total Amount</StyledTableCell>
                    <StyledTableCell>Created on</StyledTableCell>
                    {/* <StyledTableCell>Area</StyledTableCell> */}
                    {/* {isSuperAdmin && (
                      <StyledTableCell>Assigned By</StyledTableCell>
                    )} */}
                    <StyledTableCell>Status</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <StyledTableCell
                        colSpan="8"
                        style={{ textAlign: "center", height: "58vh" }}
                      >
                        <div className="d-flex align-items-center justify-content-center mt-5">
                          <div className="spinner-border spinner-border-sm text-dark"></div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  ) : invoiceData && invoiceData.length > 0 ? (
                    invoiceData.map((item, index) => (
                      <TableRow key={index}>
                        <StyledTableCell>
                          <div
                            className={`${styles.invoiceNo}`}
                            onClick={() => {
                              handlePopupDetails(
                                item.invoice_id,
                                "invoiceDetails"
                              );
                            }}
                          >
                            {item.invoice_no}
                          </div>
                        </StyledTableCell>
                        <StyledTableCell>
                          {/* <div className={`${styles.invoiceNo}`}> */}
                          {item.invoice_category || "-"}

                          {/* </div> */}
                        </StyledTableCell>
                        <StyledTableCell>
                          <div
                            className={`${styles.invoiceNo}`}
                            // onClick={() => {
                            //   handlePopupDetails(
                            //     item.emp_id,
                            //     "employerDetails"
                            //   );
                            // }}

                            onClick={(e) => {
                              handlePopupDetails(
                                item.emp_id,
                                "employerDetails"
                              );
                            }}
                          >
                            {item.company_name
                              ? textTruncate(
                                  capitalizeWords(item.company_name),
                                  20
                                )
                              : "-"}
                          </div>
                        </StyledTableCell>
                        <StyledTableCell>
                          {dateFormateDD(item.invoice_date)}
                        </StyledTableCell>
                        <StyledTableCell>{item.actual_amount}</StyledTableCell>
                        <StyledTableCell>{item.gst_amount}</StyledTableCell>
                        <StyledTableCell>{item.total_amount}</StyledTableCell>
                        <StyledTableCell>
                          {dateFormateDD(item.created_at)}
                        </StyledTableCell>
                        <StyledTableCell>
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              {item.payment_status === "cancelled" ? (
                                <span
                                  style={{
                                    backgroundColor: "#fad7a0",
                                    color: "#f39c12",
                                    padding: "5px 15px",
                                    borderRadius: "5px",
                                  }}
                                >
                                  Cancelled
                                </span>
                              ) : item.payment_status === "received" ? (
                                <span
                                  style={{
                                    backgroundColor: "#dbf6e4",
                                    color: "#169c50",
                                    padding: "5px 18px",
                                    borderRadius: "5px",
                                  }}
                                >
                                  Received
                                </span>
                              ) : (
                                item.payment_status === "pending" && (
                                  <>
                                    <span
                                      style={{
                                        backgroundColor: "#d6dbdf",
                                        color: "#5d6d7e",
                                        padding: "5px 20px",
                                        borderRadius: "5px",
                                      }}
                                    >
                                      Email sent / pending
                                    </span>{" "}
                                  </>
                                )
                              )}
                            </div>
                            <div>
                              {item.payment_status === "pending" && (
                                <span style={{ fontSize: "12px" }}>
                                  <b>
                                    {item.pending_on != null &&
                                      calculatePendingDays(
                                        item.pending_on
                                      )}{" "}
                                  </b>
                                </span>
                              )}
                            </div>
                            <div>
                              {/* Dropdown Menu */}
                              <div
                                className="btn-group dropstart"
                                style={{ cursor: "pointer" }}
                              >
                                <div
                                  className=""
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  onClick={() => setInvioceId(item)}
                                >
                                  <BsThreeDotsVertical className="fs-4" />
                                </div>
                                <ul className="dropdown-menu">
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleActionClick("pending")
                                      }
                                    >
                                      <BsDot style={{ color: "#5d6d7e" }} />{" "}
                                      Email sent / pending
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleActionClick("cancelled")
                                      }
                                    >
                                      <BsDot style={{ color: "#f39c12" }} />{" "}
                                      Cancel
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleActionClick("received")
                                      }
                                    >
                                      <BsDot style={{ color: "#169c50" }} />{" "}
                                      Received
                                    </a>
                                  </li>
                                  {/* <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() => setOpenNotes(true)}
                                    >
                                      <BsDot style={{ color: "#5d6d7e" }} />{" "}
                                      Notes
                                    </a>
                                  </li> */}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <StyledTableCell
                        colSpan="8"
                        style={{ textAlign: "center", color: "#d83f49" }}
                      >
                        <div className="mt-5">No data available</div>
                      </StyledTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mb-3 position-absolute bottom-0 start-50 translate-middle-x">
          <Stack spacing={2}>
            <Pagination
              count={dataCount.totalCount}
              page={InvoiceDataPage}
              onChange={candidatePagination}
              variant="outlined"
              shape="rounded"
              color="success"
              size="medium"
            />
          </Stack>
        </div>
      </div>
      {openInvoiceStatus && (
        <MyModal>
          <ModalContainer
            zIndex={10002}
            childComponent={
              <div style={{ width: "400px" }}>
                <div className="d-flex justify-content-between gap-2 align-items fs-5">
                  <div>
                    <b>Confirmation</b>
                  </div>
                  <div
                    className="btn btn-danger"
                    onClick={() => {
                      setOpenInvoiceStatus(false);
                      setFormdata({
                        amount_received: "",
                        reason_for_cancel: "",
                      });
                      setErrors("");
                    }}
                  >
                    <AiOutlineClose />
                  </div>
                </div>
                <div className="mt-2 mb-1">
                  {modalContent.action === "pending" ? (
                    "Are you sure you want to update it to pending?"
                  ) : modalContent.action === "cancelled" ? (
                    ""
                  ) : (
                    <p>
                      <b>
                        Balance Due :{" "}
                        {Math.floor(invoiceId.total_amount).toFixed(2)}
                      </b>
                    </p>
                  )}
                </div>
                {modalContent.action === "received" && (
                  <>
                    <label htmlFor="" style={{ fontSize: "12px" }}>
                      <b>Received Date</b>
                    </label>
                    <input
                      type="date"
                      name="amount_received_date"
                      value={formdata.amount_received_date}
                      className={`p-2 mb-2 form-control ${styles["customStatusInput"]}`}
                      onChange={handleInputChange}
                    />
                    {errors[
                      modalContent.action === "received"
                        ? "amount_received_date"
                        : "reason_for_cancel"
                    ] && (
                      <p className="text-danger" style={{ fontSize: "13px" }}>
                        {
                          errors[
                            modalContent.action === "received"
                              ? "amount_received_date"
                              : "reason_for_cancel"
                          ]
                        }
                      </p>
                    )}
                  </>
                )}
                {modalContent.showInput && (
                  <>
                    <label htmlFor="" style={{ fontSize: "12px" }}>
                      {modalContent.action === "cancelled" ? (
                        <b style={{ fontSize: "14px" }}>
                          Please provide a reason for cancellation
                        </b>
                      ) : (
                        <b>Received Amount</b>
                      )}
                    </label>
                    <input
                      type="text"
                      placeholder={modalContent.placeholder}
                      name={
                        modalContent.action === "cancelled"
                          ? "reason_for_cancel"
                          : "amount_received"
                      }
                      value={
                        modalContent.action === "cancelled"
                          ? formdata.reason_for_cancel
                          : formdata.amount_received
                      }
                      maxLength={50}
                      className={`p-2 mb-2 form-control ${styles["customStatusInput"]}`}
                      onKeyPress={(e) => {
                        if (
                          modalContent.action === "received" &&
                          !/^\d*$/.test(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onChange={handleInputChange}
                    />
                    {errors[
                      modalContent.action === "cancelled"
                        ? "reason_for_cancel"
                        : "amount_received"
                    ] && (
                      <p className="text-danger" style={{ fontSize: "13px" }}>
                        {
                          errors[
                            modalContent.action === "cancelled"
                              ? "reason_for_cancel"
                              : "amount_received"
                          ]
                        }
                      </p>
                    )}
                  </>
                )}
                {modalContent.action === "received" && (
                  <>
                    <label htmlFor="" style={{ fontSize: "12px" }}>
                      <b>Amount Adjustment Status</b>
                    </label>
                    <select
                      name="amount_adjustment_details"
                      value={
                        formdata.amount_adjustment_details ||
                        "Full amount received"
                      }
                      className={`p-2 mb-2 form-control ${styles["customStatusInput"]}`}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      <option value="TDS">TDS</option>
                      <option value="Debit note">Debit note</option>
                      <option value="Full amount received">
                        Full amount received
                      </option>
                    </select>
                  </>
                )}

                {/* {modalContent.action === "received" && (
                  <>
                    <textarea
                      type="text"
                      name="notes"
                      value={formdata.notes}
                      className={`p-2 mb-2 form-control ${styles["customStatusInput"]}`}
                      onChange={handleInputChange}
                      placeholder="Enter notes"
                    />
                    {errors[
                      modalContent.action === "received"
                        ? "notes"
                        : "reason_for_cancel"
                    ] && (
                      <p className="text-danger" style={{ fontSize: "13px" }}>
                        {
                          errors[
                            modalContent.action === "received"
                              ? "notes"
                              : "reason_for_cancel"
                          ]
                        }
                      </p>
                    )}
                  </>
                )} */}

                <div className="d-flex justify-content-end gap-2 mt-1 align-items-center">
                  <button
                    className="btn btn-success"
                    onClick={handleSubmit}
                    disabled={enableSubmit}
                  >
                    Update
                  </button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}

      {successTick && (
        <MyModal>
          <ModalContainer
            zIndex={10002}
            childComponent={<SuccessTick HeadText="Successfully" />}
          />
        </MyModal>
      )}
    </>
  );
};

export default InvoiceTableView;
